import axios from 'axios';
import store from '../Store/index';

export default {
  namespaced: true,

  state: {
    settings: {},
    selectedCampusList: [],
    selectedCampusRoute: 0,
    selectedCampus: undefined,
    campuses: [],
    showCookie: false,
    showPwa: false,
    settingValues: {},
    showPrint: false,
    orders: [],
    // Filters, search and sort of the service order list, for printing
    // the whole list while the page itself is paginated.
    orderListQuery: null
  },

  getters: {
    getSelectedCampus: state => state.selectedCampus,
    selectedCampusList: state => state.selectedCampusList,
    selectedCampusRoute: state => state.selectedCampusRoute,
    getSettings(state) {
      return state.settings;
    },
    getSettingValues: s => s.settingValues
  },

  mutations: {
    SET_ORDERS(state, value) {
      state.orders = value;
    },
    SET_ORDER_LIST_QUERY(state, value) {
      state.orderListQuery = value;
    },
    setShowPrint(state, value) {
      state.showPrint = value;
    },
    SET_SETTINGS_LOGO(state, value) {
      state.selectedCampus.logo = value;
    },
    SET_SETTING_VALUES(state, value) {
      state.settingValues = value;
    },
    SET_SETTINGS(state, value) {
      state.settings = value;
    },
    SET_CAMPUSES(state, value) {
      state.campuses = value;
    },
    SET_SELECTED_CAMPUS_LIST(state, value) {
      state.selectedCampusList = value;
    },
    SET_SELECTED_CAMPUS_ROUTE(state) {
      state.selectedCampusRoute++;
    },
    SET_SELECTED_CAMPUS(state, value) {
      if (!value) {
        state.selectedCampus = store.state.auth.user.campus;
        localStorage.setItem('campus_id', store.state.auth.user.campus.id);
      } else {
        state.selectedCampus = value;
        localStorage.setItem('campus_id', value.id);
      }
    },
    HIDE_COOKIE(state) {
      state.showCookie = false;
      localStorage.setItem('cookie', 'hide');
    },
    HIDE_PWA(state) {
      state.showPwa = false;
      localStorage.setItem('pwa', 'hide');
    },
    SHOW_COOKIE(state) {
      state.showCookie = true;
      localStorage.removeItem('cookie');
    },
    SHOW_PWA(state) {
      state.showPwa = true;
      localStorage.removeItem('pwa');
    }
  },

  actions: {
    updateSettings({ commit, dispatch }) {
      axios
        .get('/api/app-settings')
        .then(res => {
          if (!res.data.data.length) {
            setTimeout(() => {
              commit('SET_SETTINGS', store.state.auth.user);
            }, 2000);
          } else {
            commit('SET_SETTINGS', res.data.data);
          }
        })
        .catch(() => {
          commit('SET_SETTINGS', {});
        });

      const cookie = localStorage.getItem('cookie');
      const pwa = localStorage.getItem('pwa');
      if (cookie) {
        commit('HIDE_COOKIE');
      } else {
        commit('SHOW_COOKIE');
      }
      if (pwa) {
        commit('HIDE_PWA');
      } else {
        commit('SHOW_PWA');
      }

      dispatch('updateCampuses');
    },
    updateCampuses({ dispatch, rootState, commit, state }) {
      axios.get('/api/campuses').then(res => {
        const campuses = res.data.data;
        commit('SET_CAMPUSES', campuses);

        if (!state.selectedCampus) {
          const campusId = parseInt(localStorage.getItem('campus_id'));
          if (!_.isNaN(campusId) && campuses.find(c => c.id === campusId)) {
            commit(
              'SET_SELECTED_CAMPUS',
              campuses.find(c => c.id === campusId)
            );
          } else {
            commit('SET_SELECTED_CAMPUS', campuses[0]);
          }
        }
        dispatch('fetchSettings', {
          campus_id: rootState.settings.selectedCampus.id
        });
      });
    },
    fetchSettings({ rootState, commit }, params) {
      axios.get('/api/settings', { params }).then(res => {
        commit('SET_SETTING_VALUES', res.data);
      });
    },
    CHANGE_SELECTED_CAMPUS_LIST({ commit, rootState }) {
      axios
        .get('/api/study-center/categories', {
          params: {
            campus_id: rootState.settings.selectedCampus.id,
            // Menu/sidebar for the logged-in user — only centers visible
            // to their institution(s). Do NOT use this for /settings admin.
            visible_to_user: 1
          }
        })
        .then(res => {
          commit('SET_SELECTED_CAMPUS_LIST', res.data);
          commit('SET_SELECTED_CAMPUS_ROUTE');
        });
    },
    CHANGE_SELECTED_CAMPUS_ROUTE({ commit }) {
      commit('SET_SELECTED_CAMPUS_ROUTE');
    }
  }
};
